import { render, staticRenderFns } from "./LmUserProfileV2.vue?vue&type=template&id=0096801a&scoped=true&"
import script from "./LmUserProfileV2.vue?vue&type=script&lang=js&"
export * from "./LmUserProfileV2.vue?vue&type=script&lang=js&"
import style0 from "./LmUserProfileV2.vue?vue&type=style&index=0&id=0096801a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096801a",
  null
  
)

export default component.exports